import * as z from "zod";

export const updateLinearTicketLabels = {
  name: "updateLinearTicketLabels" as const,
  input: z.object({
    linearTicketId: z.string(),
    labelIds: z.array(z.string()),
  }),
  output: z.object({
    success: z.boolean(),
    newLabels: z.array(z.string()).nullable(),
    error: z.string().nullable(),
  }),
};
